function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M430 262v159h-92V272c0-37-13-63-47-63-25 0-40 18-47 34-3 6-3 14-3 23v155h-92V143h92v40h-1 1c12-19 34-46 83-46 61 0 106 39 106 125zM52 10C21 10 0 30 0 57s20 48 51 48h1c32 0 52-21 52-48-1-27-20-47-52-47zM5 421h93V143H5v278z"
});

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 430 430",
    width: 430,
    height: 430,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MzAgNDMwIiB3aWR0aD0iNDMwIiBoZWlnaHQ9IjQzMCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHBhdGggZD0iTTQzMCAyNjJ2MTU5aC05MlYyNzJjMC0zNy0xMy02My00Ny02My0yNSAwLTQwIDE4LTQ3IDM0LTMgNi0zIDE0LTMgMjN2MTU1aC05MlYxNDNoOTJ2NDBoLTEgMWMxMi0xOSAzNC00NiA4My00NiA2MSAwIDEwNiAzOSAxMDYgMTI1ek01MiAxMEMyMSAxMCAwIDMwIDAgNTdzMjAgNDggNTEgNDhoMWMzMiAwIDUyLTIxIDUyLTQ4LTEtMjctMjAtNDctNTItNDd6TTUgNDIxaDkzVjE0M0g1djI3OHoiLz48L3N2Zz4NCg==";
export { ForwardRef as ReactComponent };